import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
    makeRequest('put', `/api/courses/${id}/unsync-google-classroom/`, payload);



// WEBPACK FOOTER //
// ./src/app/services/courses/unsyncGoogleClassroomCourse.js